// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EG6oj","rootNoMargin":"styles_rootNoMargin__nBJQC"};